export const FETCH_RECIPIENTS_PENDING = 'FETCH_RECIPIENTS_PENDING';
export const FETCH_RECIPIENTS_FULFILLED = 'FETCH_RECIPIENTS_FULFILLED';
export const FETCH_RECIPIENTS_FAILED = 'FETCH_RECIPIENTS_FAILED';
export const CREATE_RECIPIENT_PENDING = 'CREATE_RECIPIENT_PENDING';
export const CREATE_RECIPIENT_FULFILLED = 'CREATE_RECIPIENT_FULFILLED';
export const CREATE_RECIPIENT_FAILED = 'CREATE_RECIPIENT_FAILED';
